import { render, staticRenderFns } from "./MiddlePages.vue?vue&type=template&id=a48425cc&"
import script from "./MiddlePages.vue?vue&type=script&lang=js&"
export * from "./MiddlePages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports